import React, {useEffect, useRef} from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

export type VariableOption = {
  key: string
  label: string
}

interface CustomPicker {
  name: string
  label: string
  icon?: string
  options: VariableOption[]
}

interface RichTextEditorProps {
  value: string
  onChange: (val: string) => void
  placeholder?: string
  delimiters?: [string, string]
  btnCustomPicker?: CustomPicker[]
}

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = '',
  delimiters = ['{{', '}}'],
  btnCustomPicker = [],
}) => {
  const quillRef = useRef<ReactQuill>(null)

  const insertVariable = (key: string) => {
    const quill = quillRef.current?.getEditor()
    if (!quill) return
    const range = quill.getSelection()
    if (range) {
      const [start, end] = delimiters
      const text = `${start}${key}${end}`
      quill.insertText(range.index, text)
      quill.setSelection(range.index + text.length, 0, 'user')
    }
  }
  const quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      ['link', 'formula'],
      [{list: 'ordered'}, {list: 'bullet'}, {list: 'check'}],
      [{indent: '-1'}, {indent: '+1'}],
      [{header: [1, 2, 3, 4, 5, 6, false]}],
      [{color: []}, {background: []}],
      [{font: []}],
      [{align: []}],
      ['clean'],
    ],
  }

  return (
    <div className='rich-text-editor'>
      {btnCustomPicker.length > 0 && (
        <div className='custom-toolbar'>
          {btnCustomPicker.map((picker) => (
            <div className='dropdown' key={picker.name}>
              <button
                className='btn btn-sm btn-outline-secondary dropdown-toggle'
                type='button'
                data-bs-toggle='dropdown'
                aria-expanded='false'
              >
                {picker.icon && <i className={`${picker.icon} me-1`} />}
                {picker.label}
              </button>
              <ul className='dropdown-menu'>
                {picker.options.map((opt) => (
                  <li key={`${picker.name}-${opt.key}`}>
                    <button
                      className='dropdown-item d-flex align-items-center'
                      onClick={() => insertVariable(opt.key)}
                    >
                      {opt.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}

      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        modules={quillModules}
        theme='snow'
      />
    </div>
  )
}
